export enum ArticlesDisplayMode {
  FEATURED = 'Featured',
  LATEST = 'Latest',
}
